var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrescriptionPad',{attrs:{"prescriptionText":_vm.prescriptionText}})
}
var staticRenderFns = []

export { render, staticRenderFns }